import { QuoteSocketUpdateI, LTPClosePriceSocketUpdate, DPRSocketUpdateI } from '../websocket/websocket.interfaces';
import { Subject } from 'rxjs';

export class Quote {

  // Quote Structure
  LTP = 0;
  AvgTradePrice = 0;
  LastTradeQty = 0;
  LastTradeTime = 0;
  LastUpdateTime = 0;
  TotalAskQty = 0;
  TotalBidQty = 0;
  Value = 0;
  Volume = 0;
  symbolId = 0;
  changeInPrice = 0;
  changePer = 0;
  closePrice = 0;
  openPrice = 0;
  highPrice = 0;
  lowPrice = 0;
  marketId = '';
  securityId = 0;

  // DPR Structure
  lowerCktLimit = 0
  upperCktLimit = 0

  // Trends
  isTickDown = false;
  isTickUp = false;
  ltpUpdate = new Subject();
  prevClosePrice = 0;
  isLtp = true;

  constructor(quote?: QuoteSocketUpdateI) {
    if (quote) {
      this.updateQuote(quote);
    }
  }

  /**
   * Update values from quote struct.
   *
   * @param {QuoteSocketUpdateI} quote
   * @memberof Quote
   */
  updateQuote(quote: QuoteSocketUpdateI, pickClosePriceInLTP: boolean = false) {
    const oldLTP = this.LTP;
    this.LTP = pickClosePriceInLTP ? quote.ClosePrice : quote.LastTradePrice;
    this.AvgTradePrice = quote.AvgTradePrice;
    this.LastTradeQty = quote.LastTradeQty;
    this.LastTradeTime = quote.LastTradeTime;
    this.LastUpdateTime = quote.LastUpdateTime;
    this.TotalAskQty = quote.TotalAskQty;
    this.TotalBidQty = quote.TotalBidQty;
    this.Value = quote.Value;
    this.Volume = quote.Volume;

    this.highPrice = quote.HighPrice;
    this.lowPrice = quote.LowPrice;
    this.openPrice = quote.OpenPrice;
    this.securityId = quote.SecurityId;
    this.marketId = quote.ExchangeId;
    if (!this.closePrice) {
      this.closePrice = quote.ClosePrice;
    }
    this.ltpUpdate.next();
    this.updateChange(oldLTP);
  }

  updateLTPCloseOnly(quote: LTPClosePriceSocketUpdate, pickClosePriceInLTP: boolean = false) {
    const oldLTP = this.LTP;
    this.LTP = pickClosePriceInLTP ? quote.ClosePrice : (quote.Ltp ? quote.Ltp : 0);
    if (!this.closePrice) {
      this.closePrice = quote.ClosePrice;
    }
    this.marketId = quote.ExchangeId;
    this.securityId = quote.SecurityId;
    this.ltpUpdate.next();
    this.updateChange(oldLTP);
  }

  /**
   * Calculate change and change ticks according to update.
   *
   * @param {number} oldLtp Old LTP for reference.
   * @memberof Quote
   */
  updateChange(oldLtp: number) {
    if (this.LastUpdateTime && this.closePrice) {
      this.changeInPrice = (this.LTP - this.closePrice);
      this.changePer = ((this.changeInPrice / this.closePrice) * 100);

      if (this.LTP < oldLtp) {
        this.isTickDown = !(this.isTickUp = false);
      } else if (this.LTP > oldLtp) {
        this.isTickUp = !(this.isTickDown = false);
      }
    } else {
      this.changePer = 0;
    }
  }

  updateDPR(update: DPRSocketUpdateI) {
    this.lowerCktLimit = update.LowerPrice;
    this.upperCktLimit = update.UpperPrice;
  }
}

export class QuoteOHLCData {
  avg_trade_price: number;
  open_price: number;
  high_price: number;
  low_price: number;
  close_price: number;
  last_trade_price: number;
  last_trade_qty: number;
  last_trade_time: number;
  total_bid_qty: number;
  total_ask_qty: number;
  last_update_time: number;
  value: number;
  volume: number;
  market_id: string;
  security_id: number;

  constructor(quote?: QuoteSocketUpdateI) {
    if (quote) {
      this.updateQuote(quote);
    }
  }

  updateQuote(quote: QuoteSocketUpdateI) {
    this.avg_trade_price = quote.AvgTradePrice;
    this.open_price = quote.OpenPrice;
    this.high_price = quote.HighPrice;
    this.low_price = quote.LowPrice;
    this.close_price = quote.ClosePrice;
    this.last_trade_price = quote.LastTradePrice;
    this.last_trade_qty = quote.LastTradeQty;
    this.last_trade_time = quote.LastTradeTime;
    this.total_bid_qty = quote.TotalBidQty;
    this.total_ask_qty = quote.TotalAskQty;
    this.last_update_time = quote.LastUpdateTime;
    this.value = quote.Value;
    this.volume = quote.Volume;
    this.market_id = quote.ExchangeId;
    this.security_id = quote.SecurityId;
  }
}

